import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './Properties.styles';
import { PropertiesItem } from '@/components/Ad/Properties/PropertiesItem';
import { useAdDetails } from '@/hooks/useAdDetails';
import { AdProperty } from '@/api/types/ads.types';
import { useServerDataContext } from '@/contexts';

export const Properties = () => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;

  const cityProperty = {
    name: t('common.city'),
    value: adData?.region || t('common.no'),
    link: null,
  } as AdProperty;

  const properties =
    adData &&
    [cityProperty, ...adData.properties].filter(
      property => property.value !== t('common.no')
    );

  return (
    <S.PropertiesBox $itemsCount={properties ? properties.length : 4}>
      {adData
        ? properties?.map((property, index) => (
            <PropertiesItem
              key={`${index}-${property.name}`}
              adProperty={property}
            />
          ))
        : Array.from({ length: 4 }, (_, index) => (
            <PropertiesItem key={index} />
          ))}
    </S.PropertiesBox>
  );
};
